export default __webpack_public_path__ + "img/tab4-bb27d5cf.png";